export class EvaluationReferrer {
  static readonly conversation = 'conversation';
  static readonly form = 'form';
  static readonly assignment = 'assignment';
  static readonly evaluationResult = 'evaluation-result';
  static readonly coachingDashboard = 'coaching-dashboard';
}
